import React from 'react'
import type { ParentProps } from 'types/explorer'
export type PaneContextType = {
  parentProps: ParentProps | null | undefined
}
export const PaneContext: React.Context<PaneContextType> =
  React.createContext<PaneContextType>({
    parentProps: null,
  })
type Props = {
  children: React.ReactNode
  value: {
    parentProps: ParentProps | null | undefined
  }
}
export const PaneProvider = ({ children, value }: Props): React.ReactNode => {
  return <PaneContext.Provider value={value}>{children}</PaneContext.Provider>
}
